import { render, staticRenderFns } from "./BranchSign.vue?vue&type=template&id=77b5e449&"
import script from "./BranchSign.vue?vue&type=script&lang=js&"
export * from "./BranchSign.vue?vue&type=script&lang=js&"
import style0 from "./BranchSign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports